export const ADMIN = 0;
export const OPERATOR = 1;
export const INSPECTOR = 2;
export const TECHNOLOGIST = 3;
export const COURIER = 4;
export const RECEPTION_POINT = 5;

export const roles = [
    { Id: ADMIN, Name: "Администратор" },
    { Id: OPERATOR, Name: "Оператор" },
    { Id: INSPECTOR, Name: "Приемщик" },
    { Id: TECHNOLOGIST, Name: "Технолог" },
    { Id: COURIER, Name: "Курьер" },
    { Id: RECEPTION_POINT, Name: "Пункт приема" }
];

const awaibleEmployeeRoles = [OPERATOR, INSPECTOR, RECEPTION_POINT];

export function getAwaibleEmployeeRoles() {
    return roles.filter(r => awaibleEmployeeRoles.some(a => a == r.Id));
}

export function getRoleNameById(roleId) {
    var role = roles.find(r => r.Id == roleId);
    if (!role)
        return '';
    return role.Name;
}

export function isAllowedFor(permission) {
    const role = sessionStorage.getItem("role");
    return permission.some(r => role == r);
}

export function getRole() {
    return sessionStorage.getItem("role");
}

export const allowedCallbacks = [ADMIN, OPERATOR, TECHNOLOGIST];
export const allowedReceptionPointCallbacks = [RECEPTION_POINT];

export const allowedOrders = [ADMIN, OPERATOR, INSPECTOR, TECHNOLOGIST, RECEPTION_POINT];
export const allowedEditOrders = [ADMIN, OPERATOR, TECHNOLOGIST, RECEPTION_POINT];
export const allowedOrdersInFabric = [ADMIN, INSPECTOR];
export const allwedOrdersOnReceivingPoint = [RECEPTION_POINT];
export const allowedOrdersUrgent = [ADMIN, OPERATOR];
export const allowedDeliveryOrders = [ADMIN, OPERATOR];
export const allowedReceptionPointDelivery = [RECEPTION_POINT, OPERATOR, ADMIN];
export const allowedOrdersOnFactory = [ADMIN, OPERATOR];
export const allowedOrdersOnIntermediatePoint = [ADMIN, OPERATOR];
export const allowedDoneOrders = [ADMIN, OPERATOR];
export const allowedCompleatedOrders = [RECEPTION_POINT];
export const allowedAllOrders = [ADMIN, OPERATOR];
export const allowedAllOnPointsOrders = [RECEPTION_POINT];
export const allowedForReceptionPointProcessed = [RECEPTION_POINT];
export const allowedForReceptionPointOrders = [ADMIN, OPERATOR];

export const allowedReadServices = [ADMIN, OPERATOR];
export const allowedEditServices = [ADMIN];

export const allowedReadClients = [ADMIN, OPERATOR, TECHNOLOGIST, RECEPTION_POINT];
export const allowedEditClients = [ADMIN, OPERATOR, TECHNOLOGIST, RECEPTION_POINT];

export const allowedReadSettings = [ADMIN, OPERATOR];
export const allowedEditSettings = [ADMIN];

export const allowManualCompletion = [ADMIN, OPERATOR];

export const allowedAnalytics = [ADMIN];

export const allowedSpecialDelivery = [ADMIN, OPERATOR];
export const allowDeliveryCancel = [ADMIN, OPERATOR];


// WEBPACK FOOTER //
// ./src/constants/permissions.js